import React, {useContext} from 'react';

const NavContext = React.createContext();

export const useNavContext = () => useContext(NavContext);

export default NavContext;
